import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16b8a82f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-code-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "base-code-title"
}
const _hoisted_3 = { class: "base-code" }
const _hoisted_4 = { class: "base-code-button" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-light fa-copy" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  Kopírovat ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Zkopírováno do schránky", -1))

import { NCode, NButton, NPopover } from 'naive-ui';
import { ref } from 'vue';
import useClipboard from 'vue-clipboard3';


export default /*#__PURE__*/_defineComponent({
  props: {
    code: { default: undefined },
    title: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { code: string, title: string }

const { toClipboard } = useClipboard();


const showPopover = ref<boolean>(false);

const copyToClipboard = async () => {
	await toClipboard(props.code);
	showPopover.value = true;
	setTimeout(() => {
		showPopover.value = false;
	}, 2000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(NPopover), {
          show: showPopover.value,
          placement: "top",
          trigger: "manual"
        }, {
          trigger: _withCtx(() => [
            _createVNode(_unref(NButton), {
              size: "tiny",
              type: "primary",
              onClick: copyToClipboard
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["show"])
      ]),
      _createVNode(_unref(NCode), {
        code: __props.code,
        language: "html",
        "word-wrap": ""
      }, null, 8, ["code"])
    ])
  ]))
}
}

})